var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({attrs:{"content-class":"tooltip-hint"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('e-svg-icon',_vm._g(_vm._b({class:_vm.classes,style:(_vm.styles),attrs:{"size":_vm.iconSize},on:{"click":_vm.onClick}},'e-svg-icon',attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]}}])},'v-tooltip',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }